import {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstLinkedItemOrDefault } from '@r-and-a-shared-ui/common-kontent-client/utils';
import section_title from './map-section_title';

const accordion_item = (
  entry: MEMBERSHIP_MODELS.AccordionItem & PLAYER_PORTALS_MODELS.AccordionItem,
) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry || {};

  return {
    title: elements?.title?.value,
    description: elements?.description,
  };
};

export const accordion = (
  entry: MEMBERSHIP_MODELS.Accordion & PLAYER_PORTALS_MODELS.Accordion,
) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry || {};

  const title = getFirstLinkedItemOrDefault(elements?.title);

  return {
    title: section_title(title as MEMBERSHIP_MODELS.SectionTitle),
    items: elements?.items?.linkedItems?.map(accordion_item),
    codename: entry?.system?.codename || '',
  };
};
